import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMessageState } from './messages';

const exampleStateSelector = createFeatureSelector<IMessageState>('message');

export const selectMessages = createSelector(
  exampleStateSelector,
  (state: IMessageState) => state.message
);
